import { parse } from "date-fns";
import { PRODUCT_TYPE } from "pages/AccountSettlementHistoryOrderId/constants/ProductType";
import { z } from "zod/mini";

import { getProductType } from "../getProductType";

import type { OrderData } from "../../types/OrderData";
import type { ProductItem } from "../../types/ProductItem";
import type { ReceiptData } from "containers/account/receipt/AccountReceipt";

const orderDataSchema = z.object({
  orderId: z.number(),
  purchasedAt: z.string(),
  totalPrice: z.number(),
  shippingFee: z.number(),
  serviceFee: z.number(),
  settlementFee: z.number(),
});

type CreateReceiptDataInput = {
  orderData: OrderData;
  orderList: ProductItem[];
  userId: string;
  userName: string;
};

export const createReceiptData = (
  input: CreateReceiptDataInput
): ReceiptData => {
  const { orderData, orderList, userId, userName } = input;

  const { data, success, error } = orderDataSchema.safeParse(orderData);
  if (!success) {
    console.error("Invalid order data:", error);
    return {
      effectiveDate: new Date(),
      spwnId: userId,
      userName,
      orderId: 0,
      shippingFee: 0,
      serviceFee: 0,
      settlementFee: 0,
      total: 0,
      breakdown: [],
    };
  }

  const {
    orderId,
    totalPrice,
    purchasedAt,
    shippingFee,
    serviceFee,
    settlementFee,
  } = data;

  const effectiveDate = parse(purchasedAt, "yyyy年M月d日", new Date());
  const breakdown = orderList.map((item) => {
    const productType = getProductType({ productType: item.type });
    const eventTitle =
      item.type === PRODUCT_TYPE.TICKET ? item.productName : null;

    return {
      eventTitle,
      productType,
      name: item.productName,
      price: item.price,
      quantity: item.quantity,
    };
  });

  return {
    effectiveDate,
    spwnId: userId,
    userName,
    orderId,
    shippingFee,
    serviceFee,
    settlementFee,
    total: totalPrice,
    breakdown,
  };
};
